import { startAppListening } from '../..';
import { setMainStatsData } from '../../reducers/common/common_reducers/mainStats';
import { getMainPageStats } from '../../reducers/common/thunks/commonInfoThunks';

startAppListening({
    actionCreator: getMainPageStats.fulfilled,
    effect: (action, store) => {
        const data = action.payload;
        store.dispatch(setMainStatsData(data));
    },
});
